export default "__VITE_ASSET__49a76139__"